// extracted by mini-css-extract-plugin
export default {"container":"MainMenu_container__9ygvJ","aboutSection":"MainMenu_aboutSection__Qu22E","link":"MainMenu_link__Y-dzp"};